import axios from "axios";
import Pool from "../modules/poolModule";
import Position from "../modules/positionModule";
import Request from "../modules/requestModule";
import Swap from "../modules/swapModule";
import { SDKConfig } from "../types";

export class TappSDK {
  protected _pool: Pool;
  protected _swap: Swap;
  protected _position: Position;

  protected _sdkConfig: SDKConfig;
  protected _request: Request;

  constructor(config: SDKConfig) {
    this._sdkConfig = config;

    const http = axios.create({
      baseURL: config.url,
    });

    this._request = new Request(http);
    this._pool = new Pool(this);
    this._swap = new Swap(this);
    this._position = new Position(this);
  }

  get Pool() {
    return this._pool;
  }

  get Swap() {
    return this._swap;
  }

  get Position() {
    return this._position;
  }

  get sdkConfig() {
    return this._sdkConfig;
  }

  get request() {
    return this._request;
  }
}
